import { UserRoleEnum } from "@/generated/graphql-hooks";

export const userRoles = {
  [UserRoleEnum.Agent]: "經紀人",
  [UserRoleEnum.Business]: "商戶",
  [UserRoleEnum.Model]: "KOL",
};
